import React from 'react'
import { useTranslation } from 'react-i18next'
import { Text, TouchableOpacity } from 'react-native'
import { paths } from '../../links'
import ProjectStore from '../Store'

export const BackButton: React.FC<{ navigation: any }> = ({ navigation }) => {
  const { t } = useTranslation('global')
  const { setUpPreviousSection, isFirstSection } = ProjectStore
  const onBack = () => {
    console.log('first section', isFirstSection) // For debugging
    if (isFirstSection) {
      if (navigation.canGoBack()) navigation.goBack()
      else navigation.navigate(paths.Console._self)
    } else {
      setUpPreviousSection()
    }
  }
  return (
    <TouchableOpacity
      style={{
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#F8F9F9',
        width: 132,
        borderRadius: 4,
      }}
      onPress={onBack}
      testID="ProjectBackButton"
    >
      <Text style={{ color: '#19262F', fontWeight: '700', fontSize: 15 }}>
        {t('ProjectForm.back-button-label')}
      </Text>
    </TouchableOpacity>
  )
}
